module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// /deploy/www/v2/sa/app/emr-webapp/~/readable-stream/transform.js
// module id = ../../../../readable-stream/transform.js
// module chunks = 5